import { RouterProvider, createBrowserRouter } from 'react-router-dom';

import ProtectedRoute from 'components/ProtectedRoute';

import Dashboard from './Dashboard';
import Department from './Department';
import DepartmentAdminsPage from './Department/Admins';
import DepartmentDesignations from './Department/Designations';
import DepartmentDivisions from './Department/Divisions';
import DepartmentIdentityCards from './Department/IdentityCards';
import DepartmentInformation from './Department/Information';
import DepartmentPrintSessionsPage from './Department/PrintSessions';
import DepartmentUsers from './Department/Users';
import CreateUser from './Department/Users/CreateUser';
import BasicInformation from './Department/Users/CreateUser/BasicInformation';
import Employee from './Department/Users/CreateUser/Employee';
import Departments from './Departments';
import ForgotPassword from './ForgotPassword';
import IdentityCard from './IdentityCard';
import IdentityCardInformation from './IdentityCard/Information';
import ScanAuditLogPage from './IdentityCard/ScanLogs';
import IdentityCardPublic from './IdentityCardPublic';
import Login from './Login';
import PrintSession from './PrintSession';
import RouteNotFound from './RouteNotFound';
import Settings from './Settings';
import Signup from './Signup';
import User from './User';
import UserDocuments from './User/Documents';
import UserCards from './User/IdentityCards';
import UserInformation from './User/Information';
import AdministrationUsers from './Users';

const router = createBrowserRouter([
  {
    path: '*',
    element: <RouteNotFound />,
  },
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/',
    element: (
      <ProtectedRoute>
        <Dashboard />
      </ProtectedRoute>
    ),
  },
  {
    path: '/signup',
    element: <Signup />,
  },
  {
    path: '/reset-password',
    element: <ForgotPassword />,
  },
  {
    path: '/users',
    children: [
      {
        index: true,
        element: (
          <ProtectedRoute>
            <AdministrationUsers />
          </ProtectedRoute>
        ),
      },
      {
        path: ':userId',
        element: (
          <ProtectedRoute>
            <User />
          </ProtectedRoute>
        ),
        children: [
          {
            index: true,
            element: (
              <ProtectedRoute>
                <UserInformation />
              </ProtectedRoute>
            ),
          },
          {
            path: 'documents',
            element: (
              <ProtectedRoute>
                <UserDocuments />
              </ProtectedRoute>
            ),
          },
          {
            path: 'identity-cards',
            element: (
              <ProtectedRoute>
                <UserCards />
              </ProtectedRoute>
            ),
          },
        ],
      },
    ],
  },
  {
    path: '/identities/:identityCardId',
    element: <IdentityCardPublic />,
  },
  {
    path: '/departments',
    children: [
      {
        index: true,
        element: (
          <ProtectedRoute>
            <Departments />
          </ProtectedRoute>
        ),
      },
      {
        path: ':departmentId',
        element: (
          <ProtectedRoute>
            <Department />
          </ProtectedRoute>
        ),
        children: [
          {
            index: true,
            element: (
              <ProtectedRoute>
                <DepartmentInformation />
              </ProtectedRoute>
            ),
          },
          {
            path: 'users',
            children: [
              {
                index: true,
                element: (
                  <ProtectedRoute>
                    <DepartmentUsers />
                  </ProtectedRoute>
                ),
              },
            ],
          },
          {
            path: 'divisions',
            element: (
              <ProtectedRoute>
                <DepartmentDivisions />
              </ProtectedRoute>
            ),
          },
          {
            path: 'designations',
            element: (
              <ProtectedRoute>
                <DepartmentDesignations />
              </ProtectedRoute>
            ),
          },
          {
            path: 'identity-cards',
            element: (
              <ProtectedRoute>
                <DepartmentIdentityCards />
              </ProtectedRoute>
            ),
          },
          {
            path: 'admins',
            element: (
              <ProtectedRoute>
                <DepartmentAdminsPage />
              </ProtectedRoute>
            ),
          },
          {
            path: 'print-sessions',
            element: (
              <ProtectedRoute>
                <DepartmentPrintSessionsPage />
              </ProtectedRoute>
            ),
          },
        ],
      },
    ],
  },
  {
    path: '/identity-cards',
    children: [
      {
        path: ':identityCardId',
        element: (
          <ProtectedRoute>
            <IdentityCard />
          </ProtectedRoute>
        ),
        children: [
          {
            index: true,
            element: (
              <ProtectedRoute>
                <IdentityCardInformation />
              </ProtectedRoute>
            ),
          },
          {
            path: 'scan-logs',
            element: (
              <ProtectedRoute>
                <ScanAuditLogPage />
              </ProtectedRoute>
            ),
          },
        ],
      },
    ],
  },
  {
    path: '/settings',
    element: (
      <ProtectedRoute>
        <Settings />
      </ProtectedRoute>
    ),
  },
  {
    path: '/print-sessions/:printSessionId',
    element: (
      <ProtectedRoute>
        <PrintSession />
      </ProtectedRoute>
    ),
  },
  {
    path: '/create',
    children: [
      {
        path: 'departments/:departmentId/user',
        element: (
          <ProtectedRoute>
            <CreateUser />
          </ProtectedRoute>
        ),
        children: [
          {
            index: true,
            element: (
              <ProtectedRoute>
                <BasicInformation />
              </ProtectedRoute>
            ),
          },
          {
            path: ':userId/basic-information',
            element: (
              <ProtectedRoute>
                <BasicInformation />
              </ProtectedRoute>
            ),
          },
          {
            path: ':userId/employee-information',
            element: (
              <ProtectedRoute>
                <Employee />
              </ProtectedRoute>
            ),
          },
        ],
      },
    ],
  },
]);

export default function App() {
  return <RouterProvider router={router} />;
}
